import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { patientoptimizationApi } from '../api/patientoptimization.api';
import { switchMap, map } from 'rxjs/operators';
import {patientoptimizationData, patientoptimization } from '../../../interfaces/masters/patientoptimization' ;
@Injectable()
export class patientoptimizationService extends patientoptimizationData {

    constructor(private api: patientoptimizationApi) {
      super();
    }
  
  
    list(url: string): Observable<patientoptimization[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<patientoptimization>{
        return this.api.getById(url);
    }
  
    create(url: string, data:patientoptimization): Observable<patientoptimization[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:patientoptimization): Observable<patientoptimization> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  